import React from 'react';
import PropTypes from 'prop-types';
import { PageHeaderStyle } from './style';

const PageHeader = props => {
  const { title, subTitle, buttons, bgColor, className, ghost } = props;
  return (
    <>
      <div
        style={{
          backgroundColor: bgColor || '#F4F5F7',
        }}
      >
        <PageHeaderStyle
          className={className}
          title={title}
          subTitle={subTitle}
          extra={buttons}
          ghost={ghost}
        />
      </div>
    </>
  );
};

PageHeader.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  bgColor: PropTypes.string,
  className: PropTypes.string,
  buttons: PropTypes.array,
  ghost: PropTypes.bool,
};

export { PageHeader };
